import React from "react"
import packageJson from '../../package.json';

const BlockCopyright = () =>
    <div className="mt-12 block font-normal text-xs text-center text-gray-600 dark:text-gray-400">
        Copyright © {new Date().getFullYear()}. Made with <span className="text-red-500">❤️</span> by <a href="/" target="_blank">EdPLATO</a>. v{packageJson.version}
    </div>

export default BlockCopyright;
